module.exports = __webpack_public_path__ + "img/user-pilot-tie.70764c89.svg";